import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Zap, Star, Check, Info, CreditCard, ArrowRight } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import { getCreditBalance } from '../../lib/api';
import { CreditPurchase } from '../payments/CreditPurchase';
export function UsageCard() {
  const {
    user
  } = useUser();
  const [credits, setCredits] = useState(0);
  const [loadingCredits, setLoadingCredits] = useState(true);
  const [showPurchase, setShowPurchase] = useState(false);
  const [isGuestMode, setIsGuestMode] = useState(false);
  useEffect(() => {
    const guestMode = localStorage.getItem('guestMode') === 'true';
    setIsGuestMode(guestMode);
    if (!guestMode) {
      loadCredits();
    }
  }, []);
  const loadCredits = async () => {
    setLoadingCredits(true);
    try {
      const balance = await getCreditBalance();
      setCredits(balance);
    } catch (error) {
      console.error('Error loading credits:', error);
      setCredits(0);
    } finally {
      setLoadingCredits(false);
    }
  };
  const freeCreditsTotal = 3;
  const remainingCredits = user?.plan.isPro ? 'Unlimited' : Math.max(0, freeCreditsTotal - (user?.usage.minutesUsed || 0));
  if (isGuestMode) {
    return <Card className="mb-6 overflow-hidden" data-id="element-123">
        <CardContent className="p-0" data-id="element-124">
          <div className="bg-gradient-to-r from-primary/10 to-primary/5 p-4 border-b border-border/20" data-id="element-125">
            <div className="flex items-center justify-between" data-id="element-126">
              <h3 className="text-lg font-medium flex items-center" data-id="element-127">
                <Zap size={18} className="text-primary mr-2" data-id="element-128" />
                Get Free Credits
              </h3>
            </div>
          </div>
          <div className="p-6 text-center" data-id="element-129">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4" data-id="element-130">
              <Star size={24} className="text-primary" data-id="element-131" />
            </div>
            <h4 className="text-xl font-semibold mb-2" data-id="element-132">
              Sign Up for 5 Free Credits
            </h4>
            <p className="text-muted-foreground mb-4" data-id="element-133">
              Create a free account to unlock comment analysis and get 5 credits
              to start.
            </p>
            <Link to="/app/settings" data-id="element-134">
              <Button className="w-full" data-id="element-135">Create Free Account</Button>
            </Link>
          </div>
        </CardContent>
      </Card>;
  }
  return <Card className="mb-6 overflow-hidden" data-id="element-136">
      <CardContent className="p-0" data-id="element-137">
        <div className="bg-gradient-to-r from-primary/10 to-primary/5 p-4 border-b border-border/20" data-id="element-138">
          <div className="flex items-center justify-between" data-id="element-139">
            <h3 className="text-lg font-medium flex items-center" data-id="element-140">
              <Zap size={18} className="text-primary mr-2" data-id="element-141" />
              Your Credits
            </h3>
            {user?.plan.isPro ? <span className="bg-primary/20 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-142">
                Unlimited Plan
              </span> : <span className="bg-secondary/70 text-secondary-foreground px-3 py-1 rounded-full text-sm" data-id="element-143">
                {credits} Credits
              </span>}
          </div>
        </div>

        <div className="p-4" data-id="element-144">
          {!user?.plan.isPro && <div className="mb-4" data-id="element-145">
              <div className="flex justify-between items-center mb-2" data-id="element-146">
                <span className="text-sm text-muted-foreground" data-id="element-147">
                  Credits Available
                </span>
                <span className="font-medium text-lg" data-id="element-148">{credits}</span>
              </div>
            </div>}

          {!user?.plan.isPro && credits <= 5 && <div className="mb-4 p-3 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800/50 rounded-lg text-amber-800 dark:text-amber-300 text-sm flex items-start" data-id="element-149">
              <Info size={16} className="mr-2 mt-0.5 flex-shrink-0" data-id="element-150" />
              <p data-id="element-151">
                {credits === 0 ? "You're out of credits! Purchase more to continue using comment analysis." : `You have ${credits} credits remaining. Each credit covers 100 comments.`}
              </p>
            </div>}

          {!user?.plan.isPro && !showPurchase && <div className="space-y-3" data-id="element-152">
              <Button className="w-full" onClick={() => setShowPurchase(true)} data-id="element-153">
                <CreditCard size={16} className="mr-2" data-id="element-154" />
                Buy Credits
              </Button>
              <Link to="/app/settings" className="block" data-id="element-155">
                <Button variant="outline" className="w-full" data-id="element-156">
                  <ArrowRight size={16} className="mr-2" data-id="element-157" />
                  View All Options in Settings
                </Button>
              </Link>
            </div>}

          {!user?.plan.isPro && showPurchase && <div className="space-y-4" data-id="element-158">
              <div className="flex items-center justify-between mb-2" data-id="element-159">
                <h4 className="font-medium" data-id="element-160">Purchase Credits</h4>
                <Button variant="ghost" size="sm" onClick={() => setShowPurchase(false)} data-id="element-161">
                  Close
                </Button>
              </div>
              <CreditPurchase currentCredits={credits} onPurchaseComplete={() => {
            loadCredits();
            setShowPurchase(false);
          }} data-id="element-162" />
            </div>}

          {user?.plan.isPro && <div className="bg-primary/10 rounded-lg p-4 border border-primary/30" data-id="element-163">
              <h4 className="flex items-center font-medium mb-2" data-id="element-164">
                <Star size={16} className="text-primary mr-2" data-id="element-165" />
                Your Unlimited Plan Benefits
              </h4>
              <ul className="text-sm grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-166">
                <li className="flex items-start" data-id="element-167">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-168" />
                  <span data-id="element-169">Unlimited transcriptions</span>
                </li>
                <li className="flex items-start" data-id="element-170">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-171" />
                  <span data-id="element-172">Priority processing</span>
                </li>
                <li className="flex items-start" data-id="element-173">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-174" />
                  <span data-id="element-175">Advanced analytics</span>
                </li>
                <li className="flex items-start" data-id="element-176">
                  <Check size={16} className="text-green-500 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-177" />
                  <span data-id="element-178">Premium support</span>
                </li>
              </ul>
            </div>}
        </div>
      </CardContent>
    </Card>;
}